var exports = {
  "g4": "loadingContainer__DvMI1o",
  "BI": "loadingHead__8xTyWE",
  "KQ": "loadingText____xFGk",
};

module.exports = exports;
